import { gql } from "apollo-boost";

export const UPDATE_PRIVATE_FEATURES = gql`
  mutation updateTeams($input: EditTeamInput!) {
    updateTeams(input: $input)
  }
`;

export const CREATE_DESIGN_ONLINE_TEAM = gql`
  mutation createDesignOnlineTeam($input: NewDesignOnlineTeam!) {
    createDesignOnlineTeam(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_DESIGN_ONLINE_TEAM = gql`
  mutation updateDesignOnlineTeam($input: EditDesignOnlineTeam!) {
    updateDesignOnlineTeam(input: $input) {
      id
      name
    }
  }
`;
export const CREATE_DESIGN_TEAM = gql`
  mutation createDesignTeam($input: CreateDesignTeam!) {
    createDesignTeam(input: $input) {
      id
      name
    }
  }
`;
//Internal Design Team

export const CREATE_INTERNAL_DESIGN_TEAM = gql`
  mutation createInternalTeam($input: CreateInternalTeam!) {
    createInternalTeam(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_INTERNAL_DESIGN_TEAM = gql`
  mutation updateInternalTeam($input: UpdateInternalTeam!) {
    updateInternalTeam(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_DESIGN_TEAM = gql`
  mutation updateDesignTeam($input: UpdateDesignTeam!) {
    updateDesignTeam(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_TEAM = gql`
  mutation updataTeam($input: UpdateTeamInput!) {
    updataTeam(input: $input)
  }
`;
export const ENABLE_PRIVATE_DATA = gql`
  mutation EnablePrivateData($teamIds: [ID!]!) {
    enablePrivateDataForTeam(teamIds: $teamIds)
  }
`;

export const CREATE_INTERNAL_TEAM = gql`
  mutation createInternalTeam($input: CreateInternalTeam!) {
    createInternalTeam(input: $input) {
      id
      name
      type
    }
  }
`;

export const UPDATE_INTERNAL_TEAM = gql`
  mutation updateInternalTeam($input: UpdateInternalTeam!) {
    updateInternalTeam(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_INTERNAL_TEAM = gql`
  mutation deleteInternalTeam($id: ID!) {
    deleteInternalTeam(id: $id)
  }
`;
